// 配置相关
// 不需要返回按钮的页面
export const noBack = [
  'doctor-card-receive',
  'doctor-card-exchange'
]
